import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        benefitStack: {
            align: 'stretch',
            gap: remCalc(10),
            paddingTop: remCalc(16),
            paddingBottom: {base: remCalc(16), lg: remCalc(0)},
        },
        icon: {
            boxSize: 'iconsSize.small',
            color: 'text.success',
        },
    },
    parts: ['icon'],
}
